import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LanguageService } from '../../../shared/services/language.service';
import Decimal from 'decimal.js/decimal.js';
import { validNumberValidator } from '../../../shared/directives/valid-number.directive';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

Decimal.set({ precision: 13, rounding: 4 });
const Decimal5 = Decimal.clone({ precision: 5, rounding: 4 }); // tslint:disable-line

@Component({
  selector: 'app-set-price',
  templateUrl: './set-price.component.html',
  styleUrls: ['./set-price.component.css'],
})
export class SetPriceComponent implements OnInit, AfterViewInit {
  setPriceForm: FormGroup;
  sent: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.setPriceForm = this.fb.group({
      amount: [
        ,
        Validators.compose([
          validNumberValidator(this.languageService),
          Validators.required,
        ]),
      ],
      negative: [true, Validators.required],
      percent: [true, Validators.required],
    });
  }

  ngAfterViewInit() {
    // setTimeout(() => this.renderer.invokeElementMethod(this.setPriceName.nativeElement, 'focus'), 100);
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.setPriceForm.valid) {
      const setPriceFormValue = this.setPriceForm.value;

      let amount = setPriceFormValue.amount;
      amount = this.languageService.unformatNumber(amount);
      amount = new Decimal5(amount).toDP(2, Decimal.ROUND_FLOOR).toNumber();

      setPriceFormValue.amount = amount;

      this.activeModal.close(setPriceFormValue);
    }
  }
}
